import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Button, Card } from "react-bootstrap";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  GearIcon,
  KeyIcon,
  OrganizationIcon,
  ShareAndroidIcon,
} from "@primer/octicons-react";
import { LuLayoutDashboard } from "react-icons/lu";
import { BiBell, BiBuildings, BiLayer, BiWrench } from "react-icons/bi";
import { TbUsers } from "react-icons/tb";
import { useTranslation } from "react-i18next";
import { UserContext } from "../UserContext";
import { hasAnyPerm } from "../utils/uiUtils";
import configInfo from "../config/config.json";

import classes from "./Sidebar.module.css";

const icons = {
  KeyIcon: <KeyIcon />,
  OrganizationIcon: <OrganizationIcon />,
  ShareAndroidIcon: <ShareAndroidIcon />,
  LuLayoutDashboard: <LuLayoutDashboard size={18} />,
  TbUsers: <TbUsers size={18} />,
  BiBuildings: <BiBuildings size={18} />,
  BiBell: <BiBell size={18} />,
  BiLayer: <BiLayer size={18} />,
  BiWrench: <BiWrench size={18} />,
  GearIcon: <GearIcon size={18} />,
};

const Sidebar = (props) => {
  const { t } = useTranslation(["common"]);

  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const { state, pathname } = useLocation();

  const [menuExpanded_UserAdmins, setMenuExpanded_UserAdmins] = useState(false);
  //const [menuExpanded_SecurityAdmins,      setMenuExpanded_KeyAdmins]      = useState(false);
  const [menuExpanded_BldgAdmins, setMenuExpanded_BldgAdmins] = useState(false);
  const [menuExpanded_IoTAdmins, setMenuExpanded_IoTAdmins] = useState(false);
  const [menuExpanded_SecurityAdmins, setMenuExpanded_SecurityAdmins] = useState(false);
  const [menuExpanded_UiAdmins, setMenuExpanded_UiAdmins] = useState(false);
  const [menuExpanded_ModelAdmins, setMenuExpanded_ModelAdmins] =
    useState(false);
  const [menuExpanded_NotifAdmins, setMenuExpanded_NotifAdmins] =
    useState(false);
  const [menuExpanded_PlatformAdmins, setMenuExpanded_PlatformAdmins] =
    useState(false);
  const [menuExpanded_SystemAdmins, setMenuExpanded_SystemAdmins] =
    useState(false);

  const [menuItemSelected, setMenuItemSelected] = useState("");

  useEffect(() => {
    // When user click on the Home button (target is set to be Console), close all menu
    if (state && state.target === "Console") {
      setMenuExpanded_UserAdmins(false);
      //setMenuExpanded_KeyAdmins(false);
      setMenuExpanded_BldgAdmins(false);
      setMenuExpanded_IoTAdmins(false);
      setMenuExpanded_SecurityAdmins(false);
      setMenuExpanded_UiAdmins(false);
      setMenuExpanded_ModelAdmins(false);
      setMenuExpanded_NotifAdmins(false);
      setMenuExpanded_PlatformAdmins(false);
      setMenuExpanded_SystemAdmins(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    const path = pathname;

    const menuMapping = {
      // UserAdmins
      "/AdminHome/UserAdmin": {
        item: "miUserAdmin",
        setParent: setMenuExpanded_UserAdmins,
      },
      "/AdminHome/UserGroupAdmin": {
        item: "miUserGroupAdmin",
        setParent: setMenuExpanded_UserAdmins,
      },
      "/AdminHome/DeptAdmin": {
        item: "miDeptAdmin",
        setParent: setMenuExpanded_UserAdmins,
      },
      "/AdminHome/RoleAdmin": {
        item: "miRoleAdmin",
        setParent: setMenuExpanded_UserAdmins,
      },
      "/AdminHome/PermissionAdmin": {
        item: "miPermissionAdmin",
        setParent: setMenuExpanded_UserAdmins,
      },

      // BldgAdmins
      "/AdminHome/DatapointAdmin": {
        item: "miDatapointAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/DatapointTypeAdmin": {
        item: "miDatapointTypeAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/AlarmCategoryAdmin": {
        item: "miAlarmCategoryAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/AlarmRuleAdmin": {
        item: "miAlarmRuleAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/LocationAdmin": {
        item: "miLocationAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/CCTVCamAdmin": {
        item: "miCCTVCamAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/AssetTypeAdmin": {
        item: "miAssetTypeAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/AssetAdmin": {
        item: "miAssetAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/AssetCollAdmin": {
        item: "miAssetCollAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/AssetImportAdmin": {
        item: "miAssetImportAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/CarparkSpaceAdmin": {
        item: "miCarparkSpaceAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/LiftAdmin": {
        item: "miLiftAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/AccessPointAdmin": {
        item: "miAccessPointAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/JobAdmin": {
        item: "miJobAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/ActionAdmin": {
        item: "miActionAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/SubsAdmin": {
        item: "miSubsAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/SubsystemAdmin": {
        item: "miSubsystemAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/FloorAdmin": {
        item: "miFloorAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/DocAdmin": {
        item: "miDocAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/SoundAdmin": {
        item: "miSoundAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/DatasourceAdmin": {
        item: "miDatasourceAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },
      "/AdminHome/DataInspectAdmin": {
        item: "miDataInspectAdmin",
        setParent: setMenuExpanded_BldgAdmins,
      },

      // NotifAdmins
      "/AdminHome/NotifTypeAdmin": {
        item: "miNotifTypeAdmin",
        setParent: setMenuExpanded_NotifAdmins,
      },
      "/AdminHome/NotifAdmin": {
        item: "miNotifAdmin",
        setParent: setMenuExpanded_NotifAdmins,
      },

      // PlatformAdmins
      "/AdminHome/CalConfigAdmin": {
        item: "miCalConfigAdmin",
        setParent: setMenuExpanded_PlatformAdmins,
      },
      "/AdminHome/UserMgmtConfigAdmin": {
        item: "miUserMgmtConfigAdmin",
        setParent: setMenuExpanded_PlatformAdmins,
      },
      "/AdminHome/MsgTmplAdmin": {
        item: "miMsgTmplAdmin",
        setParent: setMenuExpanded_PlatformAdmins,
      },
      "/AdminHome/ObjFlagAdmin": {
        item: "miObjFlagAdmin",
        setParent: setMenuExpanded_PlatformAdmins,
      },

      // UiAdmins
      "/AdminHome/UiCompTypeAdmin": {
        item: "miUiCompTypeAdmin",
        setParent: setMenuExpanded_UiAdmins,
      },
      "/AdminHome/UiCompAdmin": {
        item: "miUiCompAdmin",
        setParent: setMenuExpanded_UiAdmins,
      },
      "/AdminHome/UiAppAdmin": {
        item: "miUiAppAdmin",
        setParent: setMenuExpanded_UiAdmins,
      },

      // ModelAdmins
      "/AdminHome/ModelAdmin": {
        item: "miModelAdmin",
        setParent: setMenuExpanded_ModelAdmins,
      },
      "/AdminHome/ModelObjAdmin": {
        item: "miModelObjAdmin",
        setParent: setMenuExpanded_ModelAdmins,
      },

      // IoTAdmins
      "/AdminHome/AppAdmin": {
        item: "miAppAdmin",
        setParent: setMenuExpanded_IoTAdmins,
      },
      "/AdminHome/DeviceAdmin": {
        item: "miDeviceAdmin",
        setParent: setMenuExpanded_IoTAdmins,
      },

      // Security Admins
      "/AdminHome/DatakeyAdmin": {
        item: "miDatakeyAdmin",
        setParent: setMenuExpanded_SecurityAdmins,
      },
      "/AdminHome/DatakeyAudit": {
        item: "miDatakeyAudit",
        setParent: setMenuExpanded_SecurityAdmins,
      },

      // SystemAdmins
      "/AdminHome/TenantAdmin": {
        item: "miTenantAdmin",
        setParent: setMenuExpanded_SystemAdmins,
      },
      "/AdminHome/BizConfigAdmin": {
        item: "miBizConfigAdmin",
        setParent: setMenuExpanded_SystemAdmins,
      },
      "/AdminHome/RefDataMgmtAdmin": {
        item: "miRefDataMgmtAdmin",
        setParent: setMenuExpanded_SystemAdmins,
      },
      "/AdminHome/BatchDataProcAdmin": {
        item: "miBatchDataProcAdmin",
        setParent: setMenuExpanded_SystemAdmins,
      },
      "/AdminHome/ServiceAdmin": {
        item: "miServiceAdmin",
        setParent: setMenuExpanded_SystemAdmins,
      },
    };

    const mapping = menuMapping[path];
    if (mapping) {
      setMenuItemSelected(mapping.item);
      if (mapping.setParent) {
        mapping.setParent(true);
      }
    }
  }, [pathname]);

  // Menu callbascks
  const handleMenuClick_UserAdmins = () => {
    setMenuExpanded_UserAdmins(!menuExpanded_UserAdmins);
  };

  /*
  const handleMenuClick_KeyAdmins = () => {
    setMenuExpanded_KeyAdmins(!menuExpanded_SecurityAdmins);
  }
*/

  const handleMenuClick_BldgAdmins = () => {
    setMenuExpanded_BldgAdmins(!menuExpanded_BldgAdmins);
  };

  const handleMenuClick_IoTAdmins = () => {
    setMenuExpanded_IoTAdmins(!menuExpanded_IoTAdmins);
  };

  const handleMenuClick_SecurityAdmins = () => {
    setMenuExpanded_SecurityAdmins(!menuExpanded_SecurityAdmins);
  };

  const handleMenuClick_UiAdmins = () => {
    setMenuExpanded_UiAdmins(!menuExpanded_UiAdmins);
  };

  const handleMenuClick_ModelAdmin = () => {
    setMenuExpanded_ModelAdmins(!menuExpanded_ModelAdmins);
  };

  const handleMenuClick_NotifAdmin = () => {
    setMenuExpanded_NotifAdmins(!menuExpanded_NotifAdmins);
  };

  const handleMenuClick_SystemAdmin = () => {
    setMenuExpanded_SystemAdmins(!menuExpanded_SystemAdmins);
  };

  const handleMenuClick_PlatformAdmin = () => {
    setMenuExpanded_PlatformAdmins(!menuExpanded_PlatformAdmins);
  };

  // Menu Item callbacks
  const handleMIClick_AppAdmin = () => {
    setMenuItemSelected("miAppAdmin");
    navigate("/AdminHome/AppAdmin");
  };

  const handleMIClick_AlarmCategoryAdmin = () => {
    setMenuItemSelected("miAlarmCategoryAdmin");
    navigate("/AdminHome/AlarmCategoryAdmin");
  };

  const handleMIClick_AlarmRuleAdmin = () => {
    setMenuItemSelected("miAlarmRuleAdmin");
    navigate("/AdminHome/AlarmRuleAdmin");
  };

  const handleMIClick_DatapointAdmin = () => {
    setMenuItemSelected("miDatapointAdmin");
    navigate("/AdminHome/DatapointAdmin");
  };

  const handleMIClick_DatapointTypeAdmin = () => {
    setMenuItemSelected("miDatapointTypeAdmin");
    navigate("/AdminHome/DatapointTypeAdmin");
  };

  const handleMIClick_LocationAdmin = () => {
    setMenuItemSelected("miLocationAdmin");
    navigate("/AdminHome/LocationAdmin");
  };

  const handleMIClick_CCTVCamAdmin = () => {
    setMenuItemSelected("miCCTVCamAdmin");
    navigate("/AdminHome/CCTVCamAdmin");
  };

  const handleMIClick_AssetAdmin = () => {
    setMenuItemSelected("miAssetAdmin");
    navigate("/AdminHome/AssetAdmin");
  };

  const handleMIClick_AssetCollAdmin = () => {
    setMenuItemSelected("miAssetCollAdmin");
    navigate("/AdminHome/AssetCollAdmin");
  };

  const handleMIClick_AssetImportAdmin = () => {
    setMenuItemSelected("miAssetImportAdmin");
    navigate("/AdminHome/AssetImportAdmin");
  };

  const handleMIClick_AssetTypeAdmin = () => {
    setMenuItemSelected("miAssetTypeAdmin");
    navigate("/AdminHome/AssetTypeAdmin");
  };

  const handleMIClick_CarparkSpaceAdmin = () => {
    setMenuItemSelected("miCarparkSpaceAdmin");
    navigate("/AdminHome/CarparkSpaceAdmin");
  };

  const handleMIClick_LiftAdmin = () => {
    setMenuItemSelected("miLiftAdmin");
    navigate("/AdminHome/LiftAdmin");
  };

  const handleMIClick_AccessPointAdmin = () => {
    setMenuItemSelected("miAccessPointAdmin");
    navigate("/AdminHome/AccessPointAdmin");
  };

  const handleMIClick_DocAdmin = () => {
    setMenuItemSelected("miDocAdmin");
    navigate("/AdminHome/DocAdmin");
  };

  const handleMIClick_SoundAdmin = () => {
    setMenuItemSelected("miSoundAdmin");
    navigate("/AdminHome/SoundAdmin");
  };

  const handleMIClick_DatasourceAdmin = () => {
    setMenuItemSelected("miDatasourceAdmin");
    navigate("/AdminHome/DatasourceAdmin");
  };

  const handleMIClick_JobAdmin = () => {
    setMenuItemSelected("miJobAdmin");
    navigate("/AdminHome/JobAdmin");
  };

  const handleMIClick_SubsAdmin = () => {
    setMenuItemSelected("miSubsAdmin");
    navigate("/AdminHome/SubsAdmin");
  };

  const handleMIClick_SubsystemAdmin = () => {
    setMenuItemSelected("miSubsystemAdmin");
    navigate("/AdminHome/SubsystemAdmin");
  };

  const handleMIClick_FloorAdmin = () => {
    setMenuItemSelected("miFloorAdmin");
    navigate("/AdminHome/FloorAdmin");
  };

  const handleMIClick_ActionAdmin = () => {
    setMenuItemSelected("miActionAdmin");
    navigate("/AdminHome/ActionAdmin");
  };

  const handleMIClick_DatakeyAdmin = () => {
    setMenuItemSelected('miDatakeyAdmin');
    navigate("/AdminHome/DatakeyAdmin");
  }

  const handleMIClick_DatakeyAudit = () => {
    setMenuItemSelected('miDatakeyAudit');
    navigate("/AdminHome/DatakeyAudit");
  }

  const handleMIClick_DeptAdmin = () => {
    setMenuItemSelected("miDeptAdmin");
    navigate("/AdminHome/DeptAdmin");
  };

  const handleMIClick_DeviceAdmin = () => {
    setMenuItemSelected("miDeviceAdmin");
    navigate("/AdminHome/DeviceAdmin");
  };

  const handleMIClick_UserGroupAdmin = () => {
    setMenuItemSelected("miUserGroupAdmin");
    navigate("/AdminHome/UserGroupAdmin");
  };

  const handleMIClick_RoleAdmin = () => {
    setMenuItemSelected("miRoleAdmin");
    navigate("/AdminHome/RoleAdmin");
  };

  const handleMIClick_PermissionAdmin = () => {
    setMenuItemSelected("miPermissionAdmin");
    navigate("/AdminHome/PermissionAdmin");
  };

  const handleMIClick_UserAdmin = () => {
    setMenuItemSelected("miUserAdmin");
    navigate("/AdminHome/UserAdmin");
  };

  const handleMIClick_UiCompTypeAdmin = () => {
    setMenuItemSelected("miUiCompTypeAdmin");
    navigate("/AdminHome/UiCompTypeAdmin");
  };

  const handleMIClick_UiCompAdmin = () => {
    setMenuItemSelected("miUiCompAdmin");
    navigate("/AdminHome/UiCompAdmin");
  };

  const handleMIClick_UiAppAdmin = () => {
    setMenuItemSelected("miUiAppAdmin");
    navigate("/AdminHome/UiAppAdmin");
  };

  const handleMIClick_ModelAdmin = () => {
    setMenuItemSelected("miModelAdmin");
    navigate("/AdminHome/ModelAdmin");
  };

  const handleMIClick_ModelObjAdmin = () => {
    setMenuItemSelected("miModelObjAdmin");
    navigate("/AdminHome/ModelObjAdmin");
  };

  const handleMIClick_NotifTypeAdmin = () => {
    setMenuItemSelected("miNotifTypeAdmin");
    navigate("/AdminHome/NotifTypeAdmin");
  };

  const handleMIClick_NotifAdmin = () => {
    setMenuItemSelected("miNotifAdmin");
    navigate("/AdminHome/NotifAdmin");
  };

  const handleMIClick_ServiceAdmin = () => {
    setMenuItemSelected("miServiceAdmin");
    navigate("/AdminHome/ServiceAdmin");
  };

  const handleMIClick_DataInspectAdmin = () => {
    setMenuItemSelected("miDataInspectAdmin");
    navigate("/AdminHome/DataInspectAdmin");
  };

  const handleMIClick_RefDataMgmtAdmin = () => {
    setMenuItemSelected("miRefDataMgmtAdmin");
    navigate("/AdminHome/RefDataMgmtAdmin");
  };

  const handleMIClick_BatchDataProcAdmin = () => {
    setMenuItemSelected("miBatchDataProcAdmin");
    navigate("/AdminHome/BatchDataProcAdmin");
  };

  const handleMIClick_SaasTenantAdmin = () => {
    setMenuItemSelected("miTenantAdmin");
    navigate("/AdminHome/SaasTenantAdmin");
  };

  const handleMIClick_BizConfigAdmin = () => {
    setMenuItemSelected("miBizConfigAdmin");
    navigate("/AdminHome/BizConfigAdmin");
  };

  const handleMIClick_CalConfigAdmin = () => {
    setMenuItemSelected("miCalConfigAdmin");
    navigate("/AdminHome/CalConfigAdmin");
  };

  const handleMIClick_UserMgmtConfigAdmin = () => {
    setMenuItemSelected("miUserMgmtConfigAdmin");
    navigate("/AdminHome/UserMgmtConfigAdmin");
  };

  const handleMIClick_MsgTmplAdmin = () => {
    setMenuItemSelected("miMsgTmplAdmin");
    navigate("/AdminHome/MsgTmplAdmin");
  };

  const handleMIClick_ObjFlagAdmin = () => {
    setMenuItemSelected("miObjFlagAdmin");
    navigate("/AdminHome/ObjFlagAdmin");
  };

  // Subcomponents

  function SidebarMenu(props) {
    const MenuItemIcon = icons[props.icon];

    return (
      <>
        <Button
          className={classes.sidebar__btn_sidebar_menu}
          style={{ display: "flex" }}
          onClick={props.onClickHandler}
        >
          <span style={{ marginLeft: "8px" }}>{MenuItemIcon}</span>
          <span style={{ marginLeft: "8px" }}>{props.name}</span>
          {!props.expand ? (
            <span style={{ marginLeft: "auto", marginRight: "0px" }}>
              <ChevronDownIcon style={{ marginTop: "3px" }} />
            </span>
          ) : null}
          {props.expand ? (
            <span style={{ marginLeft: "auto", marginRight: "0px" }}>
              <ChevronUpIcon style={{ marginTop: "3px" }} />
            </span>
          ) : null}
        </Button>
      </>
    );
  }

  function SidebarMenuItem(props) {
    const MenuItemIcon = icons[props.icon];

    return (
      <>
        <Button
          className={`${
            props.selected
              ? classes.sidebar__btn_sidebar_menu_item_selected
              : classes.sidebar__btn_sidebar_menu_item
          }`}
          style={{ display: "flex" }}
          onClick={props.onClickHandler}
        >
          {props.icon ? (
            <span style={{ marginRight: "5px" }}>
              <MenuItemIcon />
            </span>
          ) : null}
          {props.name}
        </Button>
      </>
    );
  }


  // Main body

  return (
    <Card
      className={classes.sidebar}
      style={{
        width: "220px",
        minWidth: "220px",
        height: "853px",
        overflowY: "scroll",
        //backgroundColor: '#212529',
        transition: "width 0.5s, height 0.5s",
      }}
    >
      <Card.Body>
        {hasAnyPerm(
          user,
          ["UserAdminWriteAccess", "OrgAdminGeneralWriteAccess"],
          true
        ) ? (
          <>
            <SidebarMenu
              name={t("I18N_User_Admin")}
              icon="TbUsers"
              expand={menuExpanded_UserAdmins}
              onClickHandler={handleMenuClick_UserAdmins}
            />
            {menuExpanded_UserAdmins &&
            hasAnyPerm(user, ["UserAdminWriteAccess"], true) ? (
              <SidebarMenuItem
                name={t("I18N_Users")}
                selected={menuItemSelected === "miUserAdmin"}
                onClickHandler={handleMIClick_UserAdmin}
              />
            ) : null}
            {menuExpanded_UserAdmins &&
            hasAnyPerm(user, ["OrgAdminGeneralWriteAccess"], true) ? (
              <SidebarMenuItem
                name={t("I18N_User_groups")}
                selected={menuItemSelected === "miUserGroupAdmin"}
                onClickHandler={handleMIClick_UserGroupAdmin}
              />
            ) : null}
            {menuExpanded_UserAdmins &&
            configInfo.uiConfig.menuShown.USERADMIN_DEPT &&
            hasAnyPerm(user, ["OrgAdminGeneralWriteAccess"], true) ? (
              <SidebarMenuItem
                name={t("I18N_Depts")}
                selected={menuItemSelected === "miDeptAdmin"}
                onClickHandler={handleMIClick_DeptAdmin}
              />
            ) : null}
            {menuExpanded_UserAdmins &&
            hasAnyPerm(user, ["OrgAdminGeneralWriteAccess"], true) ? (
              <SidebarMenuItem
                name={t("I18N_Roles")}
                selected={menuItemSelected === "miRoleAdmin"}
                onClickHandler={handleMIClick_RoleAdmin}
              />
            ) : null}
            {menuExpanded_UserAdmins &&
            hasAnyPerm(user, ["OrgAdminGeneralWriteAccess"], true) ? (
              <SidebarMenuItem
                name={t("I18N_Permissions")}
                selected={menuItemSelected === "miPermissionAdmin"}
                onClickHandler={handleMIClick_PermissionAdmin}
              />
            ) : null}
          </>
        ) : null}


        {hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true) ? (
          <>
            <SidebarMenu
              name={t("I18N_Building_Admin")}
              icon="BiBuildings"
              expand={menuExpanded_BldgAdmins}
              onClickHandler={handleMenuClick_BldgAdmins}
            />
            {menuExpanded_BldgAdmins ? (
              <SidebarMenuItem
                name={t("I18N_Datapoints")}
                selected={menuItemSelected === "miDatapointAdmin"}
                onClickHandler={handleMIClick_DatapointAdmin}
              />
            ) : null}
            {menuExpanded_BldgAdmins ? (
              <SidebarMenuItem
                name={t("I18N_Datapoint_types")}
                selected={menuItemSelected === "miDatapointTypeAdmin"}
                onClickHandler={handleMIClick_DatapointTypeAdmin}
              />
            ) : null}
            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_ALARM_CAT ? (
              <SidebarMenuItem
                name={t("I18N_Alarm_category")}
                selected={menuItemSelected === "miAlarmCategoryAdmin"}
                onClickHandler={handleMIClick_AlarmCategoryAdmin}
              />
            ) : null}
            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_ALARM_RULE ? (
              <SidebarMenuItem
                name={t("I18N_Alarm_rules")}
                selected={menuItemSelected === "miAlarmRuleAdmin"}
                onClickHandler={handleMIClick_AlarmRuleAdmin}
              />
            ) : null}
            {menuExpanded_BldgAdmins ? (
              <SidebarMenuItem
                name={t("I18N_BldgLocations")}
                selected={menuItemSelected === "miLocationAdmin"}
                onClickHandler={handleMIClick_LocationAdmin}
              />
            ) : null}
            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_CCTV_CAM &&
            (hasAnyPerm(user, ["CCTVAdminWriteAccess"], true) ||
              user.userInfo.username === "SYSTEM") ? (
              <SidebarMenuItem
                name={t("I18N_CCTV_cams")}
                selected={menuItemSelected === "miCCTVCamAdmin"}
                onClickHandler={handleMIClick_CCTVCamAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_ASSET_TYPE ? (
              <SidebarMenuItem
                name={t("I18N_Asset_types")}
                selected={menuItemSelected === "miAssetTypeAdmin"}
                onClickHandler={handleMIClick_AssetTypeAdmin}
              />
            ) : null}
            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_ASSET ? (
              <SidebarMenuItem
                name={t("I18N_Assets")}
                selected={menuItemSelected === "miAssetAdmin"}
                onClickHandler={handleMIClick_AssetAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_ASSET_COLL ? (
              <SidebarMenuItem
                name={t("I18N_Asset_colls")}
                selected={menuItemSelected === "miAssetCollAdmin"}
                onClickHandler={handleMIClick_AssetCollAdmin}
              />
            ) : null}
            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_ASSET_IMPORT ? (
              <SidebarMenuItem
                name={t("I18N_Asset_Import")}
                selected={menuItemSelected === "miAssetImportAdmin"}
                onClickHandler={handleMIClick_AssetImportAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_CARPARK ? (
              <SidebarMenuItem
                name={t("I18N_Carpark_spaces")}
                selected={menuItemSelected === "miCarparkSpaceAdmin"}
                onClickHandler={handleMIClick_CarparkSpaceAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_LIFT ? (
              <SidebarMenuItem
                name={t("I18N_Lifts")}
                selected={menuItemSelected === "miLiftAdmin"}
                onClickHandler={handleMIClick_LiftAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_ACCESS_POINT ? (
              <SidebarMenuItem
                name={t("I18N_AccessPoints")}
                selected={menuItemSelected === "miAccessPointAdmin"}
                onClickHandler={handleMIClick_AccessPointAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            (configInfo.uiConfig.menuShown.BLDGADMIN_JOB ||
              user.userInfo.username === "SYSTEM") ? (
              <SidebarMenuItem
                name={t("I18N_Jobs")}
                selected={menuItemSelected === "miJobAdmin"}
                onClickHandler={handleMIClick_JobAdmin}
              />
            ) : null}

            {hasAnyPerm(user, ["SystemAdminFullAccess"], true) ||
            user.userInfo.username === "SYSTEM" ? (
              menuExpanded_BldgAdmins &&
              configInfo.uiConfig.menuShown.BLDGADMIN_ACTION ? (
                <SidebarMenuItem
                  name={t("I18N_Actions")}
                  selected={menuItemSelected === "miActionAdmin"}
                  onClickHandler={handleMIClick_ActionAdmin}
                />
              ) : null
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_SUBS ? (
              <SidebarMenuItem
                name={t("I18N_Data_subs")}
                selected={menuItemSelected === "miSubsAdmin"}
                onClickHandler={handleMIClick_SubsAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_SUBSYSTEM ? (
              <SidebarMenuItem
                name={t("I18N_Subsystems")}
                selected={menuItemSelected === "miSubsystemAdmin"}
                onClickHandler={handleMIClick_SubsystemAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_FLOOR ? (
              <SidebarMenuItem
                name={t("I18N_Prop_Floors")}
                selected={menuItemSelected === "miFloorAdmin"}
                onClickHandler={handleMIClick_FloorAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_DOC ? (
              <SidebarMenuItem
                name={t("I18N_Doc")}
                selected={menuItemSelected === "miDocAdmin"}
                onClickHandler={handleMIClick_DocAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_SOUND ? (
              <SidebarMenuItem
                name={t("I18N_Sounds")}
                selected={menuItemSelected === "miSoundAdmin"}
                onClickHandler={handleMIClick_SoundAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_DATASOURCE ? (
              <SidebarMenuItem
                name={t("I18N_Datasources")}
                selected={menuItemSelected === "miDatasourceAdmin"}
                onClickHandler={handleMIClick_DatasourceAdmin}
              />
            ) : null}

            {menuExpanded_BldgAdmins &&
            configInfo.uiConfig.menuShown.BLDGADMIN_DATA_INSP ? (
              <SidebarMenuItem
                name={t("I18N_Data_Inspection")}
                selected={menuItemSelected === "miDataInspectAdmin"}
                onClickHandler={handleMIClick_DataInspectAdmin}
              />
            ) : null}
          </>
        ) : null}

        {(configInfo.uiConfig.menuShown.NOTIFADMIN_NOTIFTYPE ||
          configInfo.uiConfig.menuShown.NOTIFADMIN_NOTIF) &&
        hasAnyPerm(
          user,
          ["NotifAdminDeleteAccess", "NotifTypeAdminWriteAccess"],
          true
        ) ? (
          <>
            <SidebarMenu
              name={t("I18N_Notif_Admin")}
              icon="BiBell"
              expand={menuExpanded_NotifAdmins}
              onClickHandler={handleMenuClick_NotifAdmin}
            />
            {menuExpanded_NotifAdmins &&
            configInfo.uiConfig.menuShown.NOTIFADMIN_NOTIFTYPE &&
            hasAnyPerm(user, ["NotifTypeAdminWriteAccess"], true) ? (
              <SidebarMenuItem
                name={t("I18N_Notiftypes")}
                selected={menuItemSelected === "miNotifTypeAdmin"}
                onClickHandler={handleMIClick_NotifTypeAdmin}
              />
            ) : null}
            {menuExpanded_NotifAdmins &&
            configInfo.uiConfig.menuShown.NOTIFADMIN_NOTIF &&
            hasAnyPerm(user, ["NotifAdminDeleteAccess"], true) ? (
              <SidebarMenuItem
                name={t("I18N_Notifs")}
                selected={menuItemSelected === "miNotifAdmin"}
                onClickHandler={handleMIClick_NotifAdmin}
              />
            ) : null}
          </>
        ) : null}

        {hasAnyPerm(
          user,
          ["PlatformAdminWriteAccess"],
          true || user.userInfo.username === "SYSTEM"
         ) && (configInfo.uiConfig.menuShown.PLATFORMADMIN) ? (
          <>
            <SidebarMenu
              name={t("I18N_Platform_Admin")}
              icon="BiWrench"
              expand={menuExpanded_PlatformAdmins}
              onClickHandler={handleMenuClick_PlatformAdmin}
            />
            {menuExpanded_PlatformAdmins &&
            configInfo.uiConfig.menuShown.PLATFORMADMIN_CAL_CONFIG ? (
              <SidebarMenuItem
                name={t("I18N_Cal_Config")}
                selected={menuItemSelected === "miCalConfigAdmin"}
                onClickHandler={handleMIClick_CalConfigAdmin}
              />
            ) : null}
            {menuExpanded_PlatformAdmins &&
            configInfo.uiConfig.menuShown.PLATFORMADMIN_USER_MGMT ? (
              <SidebarMenuItem
                name={t("I18N_UserMgmt_Config")}
                selected={menuItemSelected === "miUserMgmtConfigAdmin"}
                onClickHandler={handleMIClick_UserMgmtConfigAdmin}
              />
            ) : null}
            {menuExpanded_PlatformAdmins &&
            configInfo.uiConfig.menuShown.PLATFORMADMIN_MSG_TMPL ? (
              <SidebarMenuItem
                name={t("I18N_Msg_templates")}
                selected={menuItemSelected === "miMsgTmplAdmin"}
                onClickHandler={handleMIClick_MsgTmplAdmin}
              />
            ) : null}
            {menuExpanded_PlatformAdmins &&
            configInfo.uiConfig.menuShown.PLATFORMADMIN_OBJ_FLAG ? (
              <SidebarMenuItem
                name={t("I18N_Obj_Flags")}
                selected={menuItemSelected === "miObjFlagAdmin"}
                onClickHandler={handleMIClick_ObjFlagAdmin}
              />
            ) : null}
          </>
        ) : null}

        {hasAnyPerm(user, ["SystemAdminFullAccess"], true) ||
        user.userInfo.username === "SYSTEM" ? (
          <>
            <SidebarMenu
              name={t("I18N_UiAdmin")}
              icon="LuLayoutDashboard"
              expand={menuExpanded_UiAdmins}
              onClickHandler={handleMenuClick_UiAdmins}
            />
            {menuExpanded_UiAdmins ? (
              <SidebarMenuItem
                name={t("I18N_UiComp_types")}
                selected={menuItemSelected === "miUiCompTypeAdmin"}
                onClickHandler={handleMIClick_UiCompTypeAdmin}
              />
            ) : null}
            {menuExpanded_UiAdmins ? (
              <SidebarMenuItem
                name={t("I18N_UiComps")}
                selected={menuItemSelected === "miUiCompAdmin"}
                onClickHandler={handleMIClick_UiCompAdmin}
              />
            ) : null}
            {menuExpanded_UiAdmins ? (
              <SidebarMenuItem
                name={t("I18N_UiApps")}
                selected={menuItemSelected === "miUiAppAdmin"}
                onClickHandler={handleMIClick_UiAppAdmin}
              />
            ) : null}

            {configInfo.uiConfig.menuShown.MODELADMIN ? (
              <>
                <SidebarMenu
                  name={t("I18N_3dModel_Admin")}
                  icon="BiLayer"
                  expand={menuExpanded_ModelAdmins}
                  onClickHandler={handleMenuClick_ModelAdmin}
                />
                {menuExpanded_ModelAdmins ? (
                  <SidebarMenuItem
                    name={t("I18N_3dModels")}
                    selected={menuItemSelected === "miModelAdmin"}
                    onClickHandler={handleMIClick_ModelAdmin}
                  />
                ) : null}
                {menuExpanded_ModelAdmins &&
                configInfo.uiConfig.menuShown.MODELADMIN_MODELOBJMAP ? (
                  <SidebarMenuItem
                    name={t("I18N_Model_obj_maps")}
                    selected={menuItemSelected === "miModelObjAdmin"}
                    onClickHandler={handleMIClick_ModelObjAdmin}
                  />
                ) : null}
              </>
            ) : null}

            {configInfo.uiConfig.menuShown.IOTADMIN_APPS ||
            configInfo.uiConfig.menuShown.IOTADMIN_DEVICES ? (
              <SidebarMenu
                name={t("I18N_IoT_Admin")}
                icon="ShareAndroidIcon"
                expand={menuExpanded_IoTAdmins}
                onClickHandler={handleMenuClick_IoTAdmins}
              />
            ) : null}
            {menuExpanded_IoTAdmins &&
            configInfo.uiConfig.menuShown.IOTADMIN_APPS ? (
              <SidebarMenuItem
                name={t("I18N_Apps")}
                selected={menuItemSelected === "miAppAdmin"}
                onClickHandler={handleMIClick_AppAdmin}
              />
            ) : null}
            {menuExpanded_IoTAdmins &&
            configInfo.uiConfig.menuShown.IOTADMIN_DEVICES ? (
              <SidebarMenuItem
                name={t("I18N_Devices")}
                selected={menuItemSelected === "miDeviceAdmin"}
                onClickHandler={handleMIClick_DeviceAdmin}
              />
            ) : null}

            {configInfo.uiConfig.menuShown.SECADMIN_DATAKEY ||
            configInfo.uiConfig.menuShown.SECADMIN_DATAKEY_AUDIT ? (
              <SidebarMenu
                name={t("I18N_Security_Admin")}
                icon="ShareAndroidIcon"
                expand={menuExpanded_SecurityAdmins}
                onClickHandler={handleMenuClick_SecurityAdmins}
              />
            ) : null}
            {menuExpanded_SecurityAdmins &&
            configInfo.uiConfig.menuShown.SECADMIN_DATAKEY ? (
              <SidebarMenuItem
                name={t("I18N_Encryption_Keys")}
                selected={menuItemSelected === "miDatakeyAdmin"}
                onClickHandler={handleMIClick_DatakeyAdmin}
              />
            ) : null}
            {menuExpanded_SecurityAdmins &&
            configInfo.uiConfig.menuShown.SECADMIN_DATAKEY_AUDIT ? (
              <SidebarMenuItem
                name={t("I18N_Key_Audit")}
                selected={menuItemSelected === "miDatakeyAudit"}
                onClickHandler={handleMIClick_DatakeyAudit}

              />
            ) : null}

            <SidebarMenu
              name={t("I18N_System_Admin")}
              icon="GearIcon"
              expand={menuExpanded_SystemAdmins}
              onClickHandler={handleMenuClick_SystemAdmin}
            />
            {menuExpanded_SystemAdmins &&
            configInfo.uiConfig.menuShown.SYS_SAAS_TENANTS ? (
              <SidebarMenuItem
                name={t("I18N_SaasTenants")}
                selected={menuItemSelected === "miTenantAdmin"}
                onClickHandler={handleMIClick_SaasTenantAdmin}
              />
            ) : null}
            {menuExpanded_SystemAdmins ? (
              <SidebarMenuItem
                name={t("I18N_Biz_Config")}
                selected={menuItemSelected === "miBizConfigAdmin"}
                onClickHandler={handleMIClick_BizConfigAdmin}
              />
            ) : null}

            {/*
            {menuExpanded_SystemAdmins ?
               <SidebarMenuItem name={t("I18N_Data_Inspection")} selected={menuItemSelected === 'miDataInspectAdmin'}    onClickHandler={handleMIClick_DataInspectAdmin}    /> : null}
*/}

            {menuExpanded_SystemAdmins ? (
              <SidebarMenuItem
                name={t("I18N_Ref_Data_Mgmt")}
                selected={menuItemSelected === "miRefDataMgmtAdmin"}
                onClickHandler={handleMIClick_RefDataMgmtAdmin}
              />
            ) : null}
            {menuExpanded_SystemAdmins ? (
              <SidebarMenuItem
                name={t("I18N_Batch_Data_Proc")}
                selected={menuItemSelected === "miBatchDataProcAdmin"}
                onClickHandler={handleMIClick_BatchDataProcAdmin}
              />
            ) : null}
            {menuExpanded_SystemAdmins ? (
              <SidebarMenuItem
                name={t("I18N_Service_Mon")}
                selected={menuItemSelected === "miServiceAdmin"}
                onClickHandler={handleMIClick_ServiceAdmin}
              />
            ) : null}
          </>
        ) : null}
      </Card.Body>
    </Card>
  );
};

export default Sidebar;
